import {defineStore} from 'pinia'
import type {ProductListInterface} from "~~/server/types/Products";
import type {favoritesInterface} from "~~/server/types/favoritesInterface";
import {tracking} from "~/services/tracking.client";

export const useFavoritesStore = defineStore('favorites', {
    state: () => ({
        _favorites: [] as favoritesInterface[],
        _loaded: false,
        _promise: null as Promise<void> | null,
    }),
    getters: {
        favorites: s => s._favorites,
        isLoaded: s => s._loaded,
    },
    actions: {
        async load() {
            if (this._loaded) return
            if (this._promise) return this._promise;
            const { $api } = useNuxtApp()

            this._promise = (async () => {
                const res = await $api<favoritesInterface[]>('favorites', { method: 'GET' })
                this._favorites = res ?? []
                this._loaded = true
            })()

            try {
                await this._promise
            }
            finally {
                this._promise = null
            }
        },
        async fullLoad() {
            if (this._promise) return this._promise;

            const { $api } = useNuxtApp()

            this._promise = (async () => {
                const res = await $api<favoritesInterface[]>('favorites?full=true', { method: 'GET' })
                this._favorites = res ?? []
            })()

            try {
                await this._promise
            }
            finally {
                this._promise = null
            }
        },
        async add(product:ProductListInterface) {
            if (this._promise) return this._promise;
            const { $api } = useNuxtApp()

            this._promise = (async () => {
                await $api<favoritesInterface[]>('favorites/'+product.id, { method: 'PUT' })
                const index=this._favorites?.findIndex(f=>f.product_id===product.id);
                if (index !== undefined && index >= 0) {
                    this._favorites?.splice(index, 1);
                }

                    this._favorites.push({
                        product_id: product.id,
                        product: {...product}
                    });
                tracking.addToFavorites(product);
            })()

            try {
                await this._promise
            }
            finally {
                this._promise = null
            }
        },
        async remove(product_id:number) {
            if (this._promise) return this._promise;
            const { $api } = useNuxtApp()

            this._promise = (async () => {
                await $api<favoritesInterface[]>('favorites/'+product_id, { method: 'DELETE' })
                const index=this._favorites?.findIndex(f=>f.product_id===product_id);
                if (index !== undefined && index >= 0) {
                    this._favorites?.splice(index, 1);
                }
            })()

            try {
                await this._promise
            }
            finally {
                this._promise = null
            }
        },
    }

})

